import React from "react"
export const Video = ({ videoSrcURL, videoTitle, ...props }) => (
  <div className="video"  class="flex justify-center"
    style={{  
    position: "relative",
    overflow: "hidden",
    width: "100%",
    "padding-top": "56.25%"}}>
    <iframe 
      style={{
        position: "absolute",
        border: 0,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        height: "100%",
        width: "100%"}}
      src={videoSrcURL}
      title={videoTitle}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      frameBorder="0"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen
    />
  </div>
)